import React from "react";
import { useRoutes } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import { baseTheme } from './assets/global/Theme-variable';
import Themeroutes from "./routes/Router";

const App = () => {
  const routing = useRoutes(Themeroutes());  // Call Themeroutes() as it returns an array of route configs
  const theme = baseTheme;

  return (
    <ThemeProvider theme={theme}>
      {routing}
    </ThemeProvider>
  );
};

export default App;
